import { Modal } from 'bootstrap'

// Closes every open Bootstrap modal and removes leftover backdrops.
// Needed when the app navigates away programmatically while a dialog is
// open (e.g. session expired → redirect to /login): the modal element
// vanishes with the view, but Bootstrap's backdrop and the body classes
// stay behind and block the login page.
export function closeAllModals () {
  document.querySelectorAll('.modal.show').forEach((el) => {
    Modal.getInstance(el)?.hide()
  })
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
}
